// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/static/img/bucket-heads.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/static/img/rectangle-17.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.join {
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
}

.join .div {
  background-color: #ffffff;
  height: 3911px;
  overflow: hidden;
  position: relative;
  width: 1280px;
}

.join .overlap {
  height: 618px;
  left: 0;
  position: absolute;
  top: 2901px;
  width: 1386px;
}

.join .rectangle {
  height: 618px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 1280px;
}

.join .element {
  height: 456px;
  left: 776px;
  object-fit: cover;
  position: absolute;
  top: 59px;
  width: 610px;
}

.join .img {
  height: 24px;
  left: 123px;
  object-fit: cover;
  position: absolute;
  top: 244px;
  width: 487px;
}

.join .the-club-by-the {
  height: 257px;
  left: 192px;
  object-fit: cover;
  position: absolute;
  top: 212px;
  width: 545px;
}

.join .rectangle-2 {
  height: 42px;
  left: 192px;
  object-fit: cover;
  position: absolute;
  top: 513px;
  width: 180px;
}

.join .CHECK-IT-OUT {
  height: 36px;
  left: 218px;
  object-fit: cover;
  position: absolute;
  top: 515px;
  width: 129px;
}

.join .level-up-your-career {
  height: 67px;
  left: 192px;
  object-fit: cover;
  position: absolute;
  top: 116px;
  width: 369px;
}

.join .overlap-group {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 50% 50%;
  background-size: cover;
  height: 697px;
  left: 0;
  position: absolute;
  top: 144px;
  width: 1280px;
}

.join .overlap-2 {
  height: 44px;
  left: 513px;
  position: absolute;
  top: 580px;
  width: 306px;
}

.join .rectangle-3 {
  height: 42px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 2px;
  width: 267px;
}

.join .group {
  height: 42px;
  left: 39px;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 267px;
}

.join .overlap-3 {
  height: 44px;
  left: 891px;
  position: absolute;
  top: 580px;
  width: 254px;
}

.join .rectangle-4 {
  height: 42px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 2px;
  width: 254px;
}

.join .group-2 {
  height: 42px;
  left: 11px;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 218px;
}

.join .group-3 {
  height: 42px;
  left: 125px;
  object-fit: cover;
  position: absolute;
  top: 580px;
  width: 344px;
}

.join .NEW {
  height: 22px;
  left: 653px;
  object-fit: cover;
  position: absolute;
  top: 626px;
  width: 60px;
}

.join .overlap-4 {
  height: 276px;
  left: 249px;
  position: absolute;
  top: 23px;
  width: 782px;
}

.join .rectangle-5 {
  height: 35px;
  left: 158px;
  object-fit: cover;
  position: absolute;
  top: 79px;
  width: 424px;
}

.join .we-are-a-free {
  height: 276px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 782px;
}

.join .group-4 {
  height: 200px;
  left: 91px;
  object-fit: cover;
  position: absolute;
  top: 3662px;
  width: 1098px;
}

.join .stock-photo-working {
  height: 578px;
  left: -109px;
  object-fit: cover;
  position: absolute;
  top: 947px;
  width: 649px;
}

.join .element-mamas-in {
  height: 67px;
  left: 623px;
  object-fit: cover;
  position: absolute;
  top: 947px;
  width: 549px;
}

.join .stock-photo-group-of {
  height: 541px;
  left: 662px;
  object-fit: cover;
  position: absolute;
  top: 1626px;
  width: 640px;
}

.join .overlap-5 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: 50% 50%;
  background-size: cover;
  height: 415px;
  left: 0;
  position: absolute;
  top: 2280px;
  width: 1280px;
}

.join .membership-perks {
  height: 67px;
  left: 247px;
  object-fit: cover;
  position: absolute;
  top: 22px;
  width: 786px;
}

.join .deals-and-offers {
  height: 116px;
  left: 141px;
  object-fit: cover;
  position: absolute;
  top: 234px;
  width: 248px;
}

.join .mamahood-members {
  height: 88px;
  left: 536px;
  object-fit: cover;
  position: absolute;
  top: 234px;
  width: 227px;
}

.join .in-person-and-online {
  height: 88px;
  left: 910px;
  object-fit: cover;
  position: absolute;
  top: 234px;
  width: 254px;
}

.join .newsletter {
  height: 100px;
  left: 596px;
  object-fit: cover;
  position: absolute;
  top: 128px;
  width: 108px;
}

.join .gather {
  height: 60px;
  left: 982px;
  object-fit: cover;
  position: absolute;
  top: 162px;
  width: 61px;
}

.join .deals {
  height: 60px;
  left: 214px;
  object-fit: cover;
  position: absolute;
  top: 150px;
  width: 77px;
}

.join .we-have-groups-for {
  height: 376px;
  left: 621px;
  object-fit: cover;
  position: absolute;
  top: 1078px;
  width: 553px;
}

.join .IRL-meet-ups {
  height: 67px;
  left: 108px;
  object-fit: cover;
  position: absolute;
  top: 1683px;
  width: 456px;
}

.join .the-mamahood-TM {
  height: 329px;
  left: 108px;
  object-fit: cover;
  position: absolute;
  top: 1808px;
  width: 488px;
}

.join .WHITE-BUTTON {
  height: 42px;
  left: 543px;
  object-fit: cover;
  position: absolute;
  top: 2751px;
  width: 254px;
}

.join .group-5 {
  height: 69px;
  left: 31px;
  object-fit: cover;
  position: absolute;
  top: 24px;
  width: 1206px;
}
`, "",{"version":3,"sources":["webpack://./src/components/JoinPage/style.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,OAAO;EACP,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yDAAkE;EAClE,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yDAAkE;EAClE,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,OAAO;EACP,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,aAAa;AACf","sourcesContent":[".join {\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n}\n\n.join .div {\n  background-color: #ffffff;\n  height: 3911px;\n  overflow: hidden;\n  position: relative;\n  width: 1280px;\n}\n\n.join .overlap {\n  height: 618px;\n  left: 0;\n  position: absolute;\n  top: 2901px;\n  width: 1386px;\n}\n\n.join .rectangle {\n  height: 618px;\n  left: 0;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  width: 1280px;\n}\n\n.join .element {\n  height: 456px;\n  left: 776px;\n  object-fit: cover;\n  position: absolute;\n  top: 59px;\n  width: 610px;\n}\n\n.join .img {\n  height: 24px;\n  left: 123px;\n  object-fit: cover;\n  position: absolute;\n  top: 244px;\n  width: 487px;\n}\n\n.join .the-club-by-the {\n  height: 257px;\n  left: 192px;\n  object-fit: cover;\n  position: absolute;\n  top: 212px;\n  width: 545px;\n}\n\n.join .rectangle-2 {\n  height: 42px;\n  left: 192px;\n  object-fit: cover;\n  position: absolute;\n  top: 513px;\n  width: 180px;\n}\n\n.join .CHECK-IT-OUT {\n  height: 36px;\n  left: 218px;\n  object-fit: cover;\n  position: absolute;\n  top: 515px;\n  width: 129px;\n}\n\n.join .level-up-your-career {\n  height: 67px;\n  left: 192px;\n  object-fit: cover;\n  position: absolute;\n  top: 116px;\n  width: 369px;\n}\n\n.join .overlap-group {\n  background-image: url(../../../public/static/img/bucket-heads.png);\n  background-position: 50% 50%;\n  background-size: cover;\n  height: 697px;\n  left: 0;\n  position: absolute;\n  top: 144px;\n  width: 1280px;\n}\n\n.join .overlap-2 {\n  height: 44px;\n  left: 513px;\n  position: absolute;\n  top: 580px;\n  width: 306px;\n}\n\n.join .rectangle-3 {\n  height: 42px;\n  left: 0;\n  object-fit: cover;\n  position: absolute;\n  top: 2px;\n  width: 267px;\n}\n\n.join .group {\n  height: 42px;\n  left: 39px;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  width: 267px;\n}\n\n.join .overlap-3 {\n  height: 44px;\n  left: 891px;\n  position: absolute;\n  top: 580px;\n  width: 254px;\n}\n\n.join .rectangle-4 {\n  height: 42px;\n  left: 0;\n  object-fit: cover;\n  position: absolute;\n  top: 2px;\n  width: 254px;\n}\n\n.join .group-2 {\n  height: 42px;\n  left: 11px;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  width: 218px;\n}\n\n.join .group-3 {\n  height: 42px;\n  left: 125px;\n  object-fit: cover;\n  position: absolute;\n  top: 580px;\n  width: 344px;\n}\n\n.join .NEW {\n  height: 22px;\n  left: 653px;\n  object-fit: cover;\n  position: absolute;\n  top: 626px;\n  width: 60px;\n}\n\n.join .overlap-4 {\n  height: 276px;\n  left: 249px;\n  position: absolute;\n  top: 23px;\n  width: 782px;\n}\n\n.join .rectangle-5 {\n  height: 35px;\n  left: 158px;\n  object-fit: cover;\n  position: absolute;\n  top: 79px;\n  width: 424px;\n}\n\n.join .we-are-a-free {\n  height: 276px;\n  left: 0;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  width: 782px;\n}\n\n.join .group-4 {\n  height: 200px;\n  left: 91px;\n  object-fit: cover;\n  position: absolute;\n  top: 3662px;\n  width: 1098px;\n}\n\n.join .stock-photo-working {\n  height: 578px;\n  left: -109px;\n  object-fit: cover;\n  position: absolute;\n  top: 947px;\n  width: 649px;\n}\n\n.join .element-mamas-in {\n  height: 67px;\n  left: 623px;\n  object-fit: cover;\n  position: absolute;\n  top: 947px;\n  width: 549px;\n}\n\n.join .stock-photo-group-of {\n  height: 541px;\n  left: 662px;\n  object-fit: cover;\n  position: absolute;\n  top: 1626px;\n  width: 640px;\n}\n\n.join .overlap-5 {\n  background-image: url(../../../public/static/img/rectangle-17.png);\n  background-position: 50% 50%;\n  background-size: cover;\n  height: 415px;\n  left: 0;\n  position: absolute;\n  top: 2280px;\n  width: 1280px;\n}\n\n.join .membership-perks {\n  height: 67px;\n  left: 247px;\n  object-fit: cover;\n  position: absolute;\n  top: 22px;\n  width: 786px;\n}\n\n.join .deals-and-offers {\n  height: 116px;\n  left: 141px;\n  object-fit: cover;\n  position: absolute;\n  top: 234px;\n  width: 248px;\n}\n\n.join .mamahood-members {\n  height: 88px;\n  left: 536px;\n  object-fit: cover;\n  position: absolute;\n  top: 234px;\n  width: 227px;\n}\n\n.join .in-person-and-online {\n  height: 88px;\n  left: 910px;\n  object-fit: cover;\n  position: absolute;\n  top: 234px;\n  width: 254px;\n}\n\n.join .newsletter {\n  height: 100px;\n  left: 596px;\n  object-fit: cover;\n  position: absolute;\n  top: 128px;\n  width: 108px;\n}\n\n.join .gather {\n  height: 60px;\n  left: 982px;\n  object-fit: cover;\n  position: absolute;\n  top: 162px;\n  width: 61px;\n}\n\n.join .deals {\n  height: 60px;\n  left: 214px;\n  object-fit: cover;\n  position: absolute;\n  top: 150px;\n  width: 77px;\n}\n\n.join .we-have-groups-for {\n  height: 376px;\n  left: 621px;\n  object-fit: cover;\n  position: absolute;\n  top: 1078px;\n  width: 553px;\n}\n\n.join .IRL-meet-ups {\n  height: 67px;\n  left: 108px;\n  object-fit: cover;\n  position: absolute;\n  top: 1683px;\n  width: 456px;\n}\n\n.join .the-mamahood-TM {\n  height: 329px;\n  left: 108px;\n  object-fit: cover;\n  position: absolute;\n  top: 1808px;\n  width: 488px;\n}\n\n.join .WHITE-BUTTON {\n  height: 42px;\n  left: 543px;\n  object-fit: cover;\n  position: absolute;\n  top: 2751px;\n  width: 254px;\n}\n\n.join .group-5 {\n  height: 69px;\n  left: 31px;\n  object-fit: cover;\n  position: absolute;\n  top: 24px;\n  width: 1206px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
